import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Dezenter „← Übersicht"-Button (oben links) zum Zurückwechseln zur
 * Projekt-Übersicht. Wird auf Projektseiten eingebunden.
 *
 * @param {{ className?: string, onClick?: () => void }} props
 */
export default function BackToOverview({ className = '', onClick }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      className={
        'inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-sm font-medium ' +
        'text-ink-muted transition-colors hover:bg-ink/5 hover:text-ink ' +
        className
      }
    >
      <span aria-hidden="true">←</span>
      <span>Übersicht</span>
    </Link>
  );
}
